import React from 'react';
import PropTypes from 'prop-types';
import {StyledExpenseCategoryIcon} from './StyledExpenseCategoryIcon';
import {ProfileIcon} from '../../../../icons';
import {expensesHelpers} from '../../../../utils/helpers';
import {useMCCCategory} from '../../../../hooks';

const ExpenseCategoryIcon = ({
  expense,
  ...rest
}) => {

  const mccCode = expense?.mcc_code;

  const category = useMCCCategory(mccCode);

  const icon = mccCode ? expensesHelpers.getExpenseCategoryIcon(category?.id) : <ProfileIcon />;

  return (
    <StyledExpenseCategoryIcon {...rest}>
      {icon}
    </StyledExpenseCategoryIcon>
  );
}

ExpenseCategoryIcon.propTypes = {
  expense: PropTypes.object,
}

export default ExpenseCategoryIcon;
